._1kjehjc0 {
  min-height: 100%;
  background-color: var(--oq6d070);
  color: var(--oq6d074);
  padding: var(--_164xfge1u);
  padding-right: var(--_164xfge1s);
  padding-bottom: 0;
  position: relative;
}
._1kjehjc1 {
  margin: auto 0;
  max-width: 28.75rem;
  min-height: 25.25rem;
  width: 100%;
  background-color: var(--oq6d075);
  color: var(--oq6d079);
  border-radius: var(--_164xfge20);
  box-shadow: var(--_164xfge2f);
  border: var(--_164xfge25) solid var(--oq6d078);
  overflow: hidden;
}
._1kjehjc2 {
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 50%;
}
._1kjehjc3 {
  padding: 0 var(--_164xfge1u);
  border-bottom-width: var(--_164xfge25);
}
._1kjehjc4 {
  max-width: 25.125rem;
  width: 100%;
  margin: 0 auto;
  padding: var(--_164xfge1u);
  padding-top: var(--_164xfge1x);
  padding-bottom: 2.75rem;
  gap: 2.75rem;
}
._1kjehjc5 {
  padding: var(--_164xfge1s);
}